module.exports = ".basic-note {\n  visibility: visible; }\n"